// Modelos 3D: actuadores, potencia y lógica.
import { buildRelayModule, buildL298n, buildBattery } from './actuators-boards.js';
import { buildDcMotor, buildGearMotor, buildStepper28byj, buildNema17 } from './actuators-motors.js';
import { buildNpn, buildPnp, buildMosfet, buildDiode, buildHc595, buildHc165, buildL293d } from './actuators-small.js';

export const MODELS = {
  'relay-module': buildRelayModule,
  'dc-motor': buildDcMotor,
  gearmotor: buildGearMotor,
  l298n: buildL298n,
  battery: buildBattery,
  'stepper-28byj48': buildStepper28byj,
  'stepper-nema17': buildNema17,
  '74hc595': buildHc595,
  '74hc165': buildHc165,
  l293d: buildL293d,
  'npn-transistor': buildNpn,
  'pnp-transistor': buildPnp,
  'mosfet-n': buildMosfet,
  diode: buildDiode,
};
